import { useLocation, useNavigate } from "react-router-dom";
import {
  getLocalFranchiseStore,
  getStoreLocalData,
  getUserData,
} from "../../../../utils/localStorage";
import { useEffect, useState } from "react";
import { storeOrdersWithPaginationAndSearch } from "../../../../services/StoreOrder/StoreOrder";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getViewPaymentMode, getViewPaymentModeV2 } from "../../../../services/paymentMode/paymentMode";
import { bulkHomeDelivery, storeBulkProcessingPayment } from "../../../../services/BulkProcessing/BulkProcessing";
import {
  getBrandStore,
  getStoreUsersStoreConfig,
} from "../../../../services/StoreUsers/PostStoreUsers";
import SuccessModal from "../../../SuccessModal";
import AdminMenu from "../../../AdminMenu";

const { innerHeight: height } = window;

const BulkProcessingAdmin = () => {
  const navigate = useNavigate();

  const { brandProfileData, userProfileRole } = getUserData();
  const { storeLocalData } = getStoreLocalData();

  const location = useLocation();
    const { state } = location || {}; // Fallback to prevent undefined errors

  let brandId = brandProfileData.id;
  const userRole = userProfileRole;

  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [page, setPage] = useState(0);
  const [sumOfBalanceAmount, setSumOfBalanceAmount] = useState(0);
  const [sumOfOrderCount, setSumOfOrderCount] = useState(0);
  const [visible, setVisible] = useState(false);

  const [paymentMethodValue, setPaymentMethodValue] = useState("");
  const [paymentModeData, setPaymentModeData] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchFilterValue, setSearchFilterValue] = useState("INVOICE");
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);
  const [selectedStore, setSelectedStore] = useState("");
  const [storeUserData, setStoreUserData] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [selectedOrderIds, setSelectedOrderIds] = useState([]);

  const fetchStoreUser = (id) => {
    getStoreUsersStoreConfig(brandId, id)
      .then((response) => {
        if (!response.data.error) {
          // const users = response.data;
          const storeRole = response.data.filter(
            (item) =>
              item.user.role === "ROLE_STORE" && item.status === "ACTIVE"
          );
          const ResFilter = storeRole.map((item) => ({
            name: item.user.firstName + " " + item.user.lastName,
            value: item.userId,
          }));
          setStoreUserData(ResFilter);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreOrders = (data) => {
    storeOrdersWithPaginationAndSearch(selectedStore, {
      ...data,
      sortOrder: "desc",
      sortBy: "id",
      limit: 100,
      offset: page * 100, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
         

          let filterProcessingData = [];


          if (state === 'Home_Delivery') {
            filterProcessingData = Res.filter(
              item => item.deliveryRequest === false,
            );
          } else {
            filterProcessingData = Res.filter(
              item =>
                item.balanceAmount > 0 &&
                item.appliedSubscriptionDiscount === false &&
                item.subscriptionDiscount === 0,
            );
          }


          // const BalanceGreaterThanZero = Res.filter(
          //   item =>
          //     item.balanceAmount > 0 &&
          //     item.appliedSubscriptionDiscount === false &&
          //     item.subscriptionDiscount === 0,
          // );


          const selectedOrderIds = selectedRows.map(item => item.id);


          const updatedOrderItems = filterProcessingData.map(item => ({
            ...item,
            checked: selectedOrderIds.includes(item.id),
          }));


          if (page === 0) {
            setCustomerALLOrdersData(updatedOrderItems);
          } else {
            setCustomerALLOrdersData(prevData => [
              ...prevData,
              ...updatedOrderItems,
            ]);
          }

        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  // for all status and one week data or by default data;
  const data = {
    storeIds: [selectedStore],
    brandId: brandId,
    statusIn: [
      "BOOKED",
      "INPROCESS",
      "IN_WAREHOUSE",
      "PROCESSED",
      "DELIVERED",
      // "DONE",
      // "CANCEL",
      // "UNPROCESSED",
      "OUT_FOR_DELIVERY",
      "DELAY_STATUS",
    ],
    recordType: "",
  };
  const [requestData, setRequestData] = useState(data);

  const [paymentError, setPaymentError] = useState("");

  const fetchPaymentMode = () => {
    getViewPaymentModeV2(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data?.paymentModes.filter(
            (item) => item !== "ONLINE" && item !== "USER_ACCOUNT"
          );
          setPaymentModeData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  const [brandStoreData, setBrandStoreData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await getBrandStore(brandId);
      if (!response.data.error) {
        const Res = response.data;
        setBrandStoreData(Res);
        const storeIds = Res.map((item) => item.id);
        setSelectedStore(selectedStore || storeIds[0])
        fetchStoreUser(storeIds[0]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

   const fetchFranchiseStore = async () => {
      const franchiseStore = await getLocalFranchiseStore();
      if (franchiseStore.franchiseStore !== null) {
        const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
        setBrandStoreData(Res);
        const storeIds = Res.map((item) => item.id);
        setSelectedStore(selectedStore || storeIds[0]);
        fetchStoreUser(storeIds[0]);
      } else {
        setBrandStoreData([]); 
        setSelectedStore("");
      }
    };

  useEffect(() => {
     if (userRole === "BY_FRANCHISE_ADMIN") {
       fetchFranchiseStore();
     } else {
       fetchData();
     }
    fetchPaymentMode();
  }, []);

  useEffect(() => {
    const requestValue = {
      ...requestData,
      searchBy: searchFilterValue !== "" ? searchFilterValue : "INVOICE",
      searchText: searchTerm,
    };
    if (page > 0) fetchStoreOrders(requestValue);
  }, [page]);

  const handleSearchFilterChange = async (selectedItem) => {
    setSearchFilterValue(selectedItem);
    handleSearchType();
  };

  const FilterList = [
    {
      name: "By Name",
      value: "NAME",
    },
    {
      name: "By Invoice No.",
      value: "INVOICE",
    },
    {
      name: "By Mobile No.",
      value: "MOBILE",
    },
  ];

  const handleSearchType = () => {
    setSearchTypeToggle(!searchTypeToggle);
  };


  let RequiredStatus = [];


  if (state === 'Home_Delivery') {
    RequiredStatus = [
      'BOOKED',
      'INPROCESS',
      'IN_WAREHOUSE',
      'PROCESSED',
      'DELAY_STATUS',
      'UNPROCESSED',
    ];
  } else {
    RequiredStatus = [
      'BOOKED',
      'INPROCESS',
      'IN_WAREHOUSE',
      'PROCESSED',
      'DELIVERED',
      'OUT_FOR_DELIVERY',
      'DELAY_STATUS',
    ];
  }


  const searchTermApiCall = (text) => {
    if (text !== "") {
      setSearchTerm(text);
      setPage(0);
      const requestValue = {
        // ...requestData,
        storeIds: [selectedStore],
        brandId: brandId,
        recordType: "",
        statusIn: RequiredStatus,
        startDate: null,
        endDate: null,
        offset: 0,
        searchBy: searchFilterValue !== "" ? searchFilterValue : "INVOICE",
        searchText: text,
      };
      fetchStoreOrders(requestValue);
    } else {
      setSearchTerm("");
      setCustomerALLOrdersData([]);
      setPage(0);
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setCustomerALLOrdersData([]);
    setSelectedInvoiceNos([])
    setPage(0);
  };

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const [tabularView, setTabularView] = useState("tab");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedInvoiceNos, setSelectedInvoiceNos] = useState([]);

  const statusBodyTemplate = (rowData) => {
    return (
      <div className="flex flex-row justify-content-between">
        <span style={{ color: OrderStatusColors[rowData.status] }}>
          {rowData?.status?.replace(/_/g, " ")}
        </span>
      </div>
    );
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div  >
        <span >
          {rowData?.invoiceNo}
        </span>
      </div>
    );
  };

  const renderPaymentModeButtons = () => {
    return brandStoreData?.map((item) => (
      <div
        key={item.id}
        style={{
          backgroundColor: item.id === selectedStore ? "green" : "#3EB3E1",
        }}
        className="px-3 py-2 border-round-md cursor-pointer"
        onClick={() => {
          setSelectedStore(item.id);
          fetchStoreUser(item.id);

          setCustomerALLOrdersData([]);
          handleClearSearch();
          setSelectedRows([]);
          setSelectedInvoiceNos([])
          setSumOfBalanceAmount(0);
          setSumOfOrderCount(0);
          setPaymentMethodValue("")
          setStoreUserValue("")
        }}
      >
        <p className="text-white text-xl font-bold uppercase">
          {item?.storeName.replace(/_/g, " ")}
        </p>
      </div>
    ));
  };


  const handleSelectionChange = (e) => {
    setSelectedRows(e.value);
    const invoiceNumber = e.value.map((row) => row.invoiceNo);
    setSelectedInvoiceNos(invoiceNumber);
    const invoiceId = e.value.map((row) => row.id);
    setSelectedOrderIds(invoiceId);
    updateStatusTotals(e.value);
  };

  // Update status totals based on fetched data
  const updateStatusTotals = (orders) => {
    const statusTotals = orders.reduce((acc, order) => {
      const existingStatus = acc.find((item) => item.status === order.status);

      if (existingStatus) {
        existingStatus.balanceAmountSum += order.balanceAmount;
        existingStatus.orderCount += 1;
      } else {
        acc.push({
          status: order.status,
          balanceAmountSum: order.balanceAmount,
          orderCount: 1,
        });
      }
      return acc;
    }, []);

    const totalBalanceAmountSumData = statusTotals.reduce(
      (acc, item) => acc + item.balanceAmountSum,
      0
    );
    const totalOrderCountData = statusTotals.reduce(
      (acc, item) => acc + item.orderCount,
      0
    );

    setSumOfBalanceAmount(totalBalanceAmountSumData);
    setSumOfOrderCount(totalOrderCountData);
  };

  const [storeUserValue, setStoreUserValue] = useState("");
  const handlePaymentMethodChange = (charge) => {
    setPaymentMethodValue(charge);
    setPaymentError("");
  };

  const handleStoreUserValueChange = (storeUserId) => {
    setStoreUserValue(storeUserId);
  };

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerALLOrdersData}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "40rem" }}
        selectionMode="checkbox"
        selection={selectedRows}
        onSelectionChange={handleSelectionChange}
        stripedRows
        scrollable
        scrollHeight={height - 200}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          selectionMode="multiple"
          //  header="Select All"
          style={{ width: "50px" }}
        ></Column>

        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{ width: "130px" }}
          body={invoiceBodyTemplate}
        ></Column>

        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "180px" }}
          body={(rowData) => rowData?.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="paidAmount"
          header="Paid Amount"
          style={{ width: "150px" }}
        ></Column>
        <Column
          field="balanceAmount"
          header="Balance"
          style={{ width: "100px" }}
        ></Column>
      </DataTable>
    );
  };

  const RenderSelectedTabView = () => {
    return (
      <DataTable
        showGridlines
        value={selectedRows}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "40rem" }}
        stripedRows
        scrollable
        scrollHeight={height - 200}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{ width: "130px" }}
          body={invoiceBodyTemplate}
        ></Column>

        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "180px" }}
          body={(rowData) => rowData?.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="paidAmount"
          header="Paid Amount"
          style={{ width: "150px" }}
        ></Column>
        <Column
          field="balanceAmount"
          header="Balance"
          style={{ width: "100px" }}
        ></Column>
      </DataTable>
    );
  };

  const handleCollectPayment = () => {
    if (paymentMethodValue === "") {
      setPaymentError("Please select any Payment Method");
    } else {
      setPaymentError("");
      if (!isPayNowButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsPayNowButtonPressed(true);
        const data = {
          orderIds: selectedOrderIds,
          receivedBy: storeUserValue,
          totalPaidAmount: sumOfBalanceAmount,
          paymentMode: paymentMethodValue,
        };


        storeBulkProcessingPayment(selectedStore, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;

              if (Res.status === "success") {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(`Submitted Amount ${Res.requestSettledAmount} and Settled Amount ${Res.totalSettledAmount}`);
              } else {
                setModalVisible(true);
                setModalStatus("notSuccess");
                setModalText(Res.status);
              }
              setCustomerALLOrdersData([])
                handleClearSearch()
                setSelectedRows([])
                setSelectedInvoiceNos([])
                setSumOfBalanceAmount(0);
                setSumOfOrderCount(0);
                setIsPayNowButtonPressed(false)
                setPaymentMethodValue("")
                setStoreUserValue("")
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    }
  };


  const handleHomeDelivery = () => {
    if (!customerALLOrdersData) return;
    setIsPayNowButtonPressed(true);
    const data = {
      orderIds: selectedOrderIds,
    };
    bulkHomeDelivery(data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            setModalVisible(true);
            setModalStatus('success');
            setModalText('Orders UpDated Successfully');
          } else {
            setModalVisible(true);
            setModalStatus('notSuccess');
            setModalText('Orders UpDated Failed');
          }
          setCustomerALLOrdersData([]);
          setSelectedInvoiceNos([]);
          setSelectedOrderIds([]);
          handleClearSearch();
          setSelectedRows([]);
          setSumOfBalanceAmount(0);
          setSumOfOrderCount(0);
          setIsPayNowButtonPressed(false);
          setPaymentMethodValue('');
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  }

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/BulkProcessingList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Bulk {state.replace(/_/g," ")}
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div
        className="flex gap-3 my-3 mx-3 pb-1 new-scroll-bar"
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        <div className="ml-2 flex justify-content-between  align-items-center">
          <div>
            <p className="text-xl font-semibold">Select Store : </p>
          </div>
        </div>

        {renderPaymentModeButtons()}
      </div>

      {selectedStore && (
        <div className="  my-2">
          <div className="my-2 mx-5 flex flex-1">
            <div className="flex-1 flex justify-content-center">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"> </InputIcon>
                <InputText
                  placeholder={
                  searchFilterValue === "NAME"
                    ? "Search By Name"
                    : searchFilterValue === "MOBILE"
                    ? "Search By Mobile No."
                    : "Search By Invoice No."
                }
                value={searchTerm}
                keyboardType={
                  searchFilterValue === "NAME" ? "default" : "numeric"
                }
                  onChange={(e) => searchTermApiCall(e.target.value)}
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
            </div>

            {searchTerm ? (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-4xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          ) : (
            <div
              onClick={handleSearchType}
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                  style={{ width: 27 }}
                />
              </div>
            </div>
          )}
          </div>

          {searchTypeToggle && (
          <div className="flex-1 mx-5 mb-4 mt-4">
            <Dropdown
              value={searchFilterValue}
              onChange={(e) => handleSearchFilterChange(e.value)}
              options={FilterList}
              optionLabel="name"
              placeholder="Search Filter"
              className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
            />
          </div>
        )}

          {sumOfOrderCount > 0 && (
            <div className="flex direction-row   mt-3">
            {state === "Home_Delivery" && <div
              className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar cursor-pointer"
              onClick={handleHomeDelivery}
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div
                style={{ backgroundColor: isPayNowButtonPressed ? '#c2c2c2' : '#2B70D7', paddingTop:"10px", paddingBottom:"9px" }}
                className="px-3 border-round-md flex flex-row gap-5"
              >
                <p className="text-white text-lg font-bold uppercase">
                {sumOfOrderCount} - Ready For Home Delivery
                </p>
                <p className="text-white text-lg font-bold uppercase">
                  Click Here
                </p>
              </div>
            </div>}
            {state === "Payment" &&  
            
            <div className="flex">
            <div
                className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar"
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                <div
                  style={{ backgroundColor: "#2B70D7", paddingTop:"10px", paddingBottom:"9px" }}
                  className="px-3 border-round-md"
                >
                  <p className="text-white text-lg font-bold uppercase">
                        {sumOfOrderCount} - Total Balance Amount ({storeLocalData?.currencySymbol}{" "}
                    {sumOfBalanceAmount.toFixed(0)})
                  </p>
                </div>
              </div>

              <div className="mx-4">
                <div className="flex flex-1 ">
                  <Dropdown
                    value={paymentMethodValue}
                    onChange={(e) => handlePaymentMethodChange(e.value)}
                    options={paymentModeData}
                    optionLabel="name"
                    placeholder="Payment Method"
                    disabled={isPayNowButtonPressed}
                    className="w-16rem  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                  />
                </div>

                <div>
                  {paymentError !== "" && (
                    <p className="text-md" style={{ color: "red" }}>
                      {paymentError}
                    </p>
                  )}
                </div>
              </div>

              {paymentMethodValue && (
                <div className="mx-4">
                  <div className="flex flex-1 ">
                    <Dropdown
                      value={storeUserValue}
                      onChange={(e) => handleStoreUserValueChange(e.value)}
                      options={storeUserData}
                      optionLabel="name"
                      placeholder="Store Manager"
                      disabled={isPayNowButtonPressed}
                      className="w-20rem  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                    />
                  </div>

                  <div>
                    {paymentError !== "" && (
                      <p className="text-md" style={{ color: "red" }}>
                        {paymentError}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {storeUserValue && (
                <Button
                  className="flex border-round-xl mb-3 mx-4 py-1 px-3"
                  onClick={handleCollectPayment}
                  disabled={isPayNowButtonPressed}
                >
                  <p className=" w-full text-xl font-semibold flex justify-content-center">
                    Pay Now
                  </p>
                </Button>
              )}
              </div>
            }
            </div>
          )}

          <div className="flex" style={{
                  pointerEvents: isPayNowButtonPressed ? "none" : "auto",
                }}>
            <div>
              <div className="flex justify-content-center">
                <p className="text-xl font-semibold underline p-2">
                  Please Select Invoice
                </p>
              </div>
              {tabularView === "tab" && (
                <div
                  className="scroll-bar mb-2"
                   
                >
                  <div className="mx-4 report-table">
                    <div className="tab-view-table">{RenderTabView()}</div>
                  </div>
                </div>
              )}
            </div>

            <div>
              <div className="flex justify-content-center">
                <p className="text-xl font-semibold underline p-2">
                  Selected Invoices
                </p>
              </div>
              {tabularView === "tab" && (
                <div
                  className="scroll-bar mb-2"
                   
                >
                  <div className="mx-4 report-table">
                    <div className="tab-view-table">
                      {RenderSelectedTabView()}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />

          <AdminMenu setVisible={setVisible} visible={visible} />
        </div>
      )}
    </div>
  );
};

export default BulkProcessingAdmin;
